import React from "react";
import "./index.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebookSquare,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

import logo from "../../assets/Images/logo.png";
import Tecworks from "../../assets/Images/tecworks.png";
import Truck from "../../assets/Images/truck.png";
import Marker from "../../assets/Images/map.png";
import Phone from "../../assets/Images/phone.png";
import Clock from "../../assets/Images/clock.png";
// import MastercardCinza from '../../assets/Images/mastercard-cinza.png'
// import EloCinza from '../../assets/Images/elo-cinza.png'
// import VisaCinza from '../../assets/Images/visa-cinza.png'
// import RapidSSL from '../../assets/Images/rapidssl-cinza.png'
// import SiteBlindado from '../../assets/Images/siteblindado-cinza.png'

// Import de Componentes Bootstrap
import {
  Row,
  Col,
  Container,
  InputGroup,
  FormControl,
  Button,
} from "react-bootstrap";

const Footer: React.FC = () => {
  return (
    <>
      <footer>
        <Row className="w-100 footer-logo-container">
          <img src={logo} alt="logo Domakoski" />
        </Row>
        <Container className="mb-5 footer-top-bar">
          <Row className="footer-item-row">
            <Col xs={12} md={6} className="footer-item">
              <span className="icon-wrapper">
                <img src={Truck} style={{ marginRight: "5px" }} alt="" />
              </span>
              <h4>
                <a href="/">
                  {" "}
                  Clique aqui para consultar as modalidades de tempo e entrega{" "}
                </a>
              </h4>
            </Col>
            <Col xs={12} md={6} className="footer-item">
              <span className="icon-wrapper">
                <img src={Marker} alt="" />
              </span>
              <h4>Rua Des. Otávio do Amaral, 827 Bigorrilho - Curitiba/PR</h4>
            </Col>
          </Row>
          <Row className="footer-item-row">
            <Col xs={12} md={6} className="footer-item">
              <span className="icon-wrapper">
                <img src={Phone} alt="" />
              </span>
              <h4>(41) 3335-7161</h4>
            </Col>
            <Col xs={12} md={6} className="footer-item">
              <span className="icon-wrapper">
                <img src={Clock} alt="" />
              </span>
              <Row>
                <Col>
                  <h4>Seg à Sex</h4>
                  <p>8:00h às 19:30h</p>
                  <h4 className="sabado">Sábado</h4>
                  <p>8:00h às 19:00h</p>
                </Col>
                <Col>
                  <h4>Dom e Feriados</h4>
                  <p>8:00h às 13:00h</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>

        <hr className="horizontal-rule" />

        <Container fluid className="mt-5 footer-middle-bar">
          <Row className="mx-0">
            <Col lg={4} className="newsletter-container">
              <h2 className="newsletter-title"> Não perca </h2>
              <h4 className="newsletter-text">
                Nossas ofertas, promoções e lançamentos.{" "}
                <span className="newsletter-highlight"> Inscreva-se </span>
                para receber atualizações por E-mail.
              </h4>
              <InputGroup className="mt-5 search-box-container">
                <InputGroup.Prepend>
                  <InputGroup.Text
                    id="envelope-mail"
                    className="text-input-addon"
                  >
                    <FontAwesomeIcon icon={faEnvelope} />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  size="lg"
                  className="search-box-input"
                  type="email"
                  placeholder="Insira seu E-mail"
                  aria-label="Newsletter"
                  aria-describedby="Insira seu e-mail para cadastrar-se em nossa newsletter"
                />
                <InputGroup.Prepend>
                  <Button className="btn-primary-action"> Inscrever </Button>
                </InputGroup.Prepend>
              </InputGroup>
            </Col>
            <Col lg={8}>
              <Row className="footer-links-container">
                <Col sm={12} md={3} className="footer-links">
                  <h5> Atendimento </h5>
                  <a href="/central-do-cliente"> Central do Cliente </a>
                  <a href="/meu-cadastro"> Meu perfil </a>
                  <a href="/meus-pedidos"> Meus pedidos </a>
                  <a href="/"> Política de Trocas e Devoluções </a>
                  <a href="/contato"> Fale conosco </a>
                </Col>
                <Col sm={12} md={3} className="footer-links">
                  <h5> Categorias </h5>
                  <a href="/"> Bovinos </a>
                  <a href="/"> Suinos </a>
                  <a href="/"> Ovinos e Caprinos </a>
                  <a href="/"> Pescados </a>
                  <a href="/"> Frango </a>
                  <a href="/"> Exóticos </a>
                  <a href="/"> Temperados </a>
                  <a href="/"> Preparados/Recheados </a>
                  <a href="/"> Angus Prime </a>
                  <a href="/"> Kobe Beef </a>
                  <a href="/"> Vitelo </a>
                  <a href="/"> Queijos </a>
                </Col>
                <Col sm={12} md={3} className="footer-links">
                  <h5> Institucional </h5>
                  <a href="/sobre-nos"> Sobre nós </a>
                  <a href="/receitas"> Receitas </a>
                  <a href="/dicas"> Dicas </a>
                  <a href="/"> Eventos </a>
                  <a href="/"> Solicite um Orçamento </a>
                </Col>
              </Row>
            </Col>
            {/* <Col sm={6} md={12} lg={4} xl={3} className="footer-links pag-seg">
              <h5> Segurança </h5>
              <div className="brands-img">
                <Image src={SiteBlindado}/>
                <Image src={RapidSSL}/>
              </div>
            </Col>
            <Col sm={6} md={4} lg={4} xl={3} className="footer-links pag-seg">
              <h5> Pagamento </h5>
              <div className="brands-img">
                <Image src={VisaCinza}/>
                <Image src={EloCinza}/>
                <Image src={MastercardCinza}/>
              </div>
            </Col> */}
          </Row>
        </Container>

        <hr className="mt-5 footer-hr" />

        <Row className="w-100 py-2 footer-bottom-bar">
          <Col md={4} lg={4}>
            <p className="copyright"> Açougue Domakoski & Cia Ltda </p>
          </Col>
          <Col md={8} lg={4} className="px-0 d-flex social">
            <a
              href="https://www.facebook.com/AcougueDomakoski/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faFacebookSquare}
                className="social-icon"
              />
            </a>
            <a
              href="https://www.instagram.com/acouguedomakoski/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} className="social-icon" />
            </a>
            <a
              href="https://www.youtube.com/watch?v=ACjT3zfZ-aw&list=PLjHtHkXIXyUgS1_wGssrQSix8NJm-TmAk"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faYoutube} className="social-icon" />
            </a>
          </Col>
          <Col md={12} lg={4} className="pl-0">
            <p className="tecworks">
              {" "}
              Desenvolvido por Grupo TecWorks{" "}
              <img src={Tecworks} alt="logo Tecworks" />{" "}
            </p>
          </Col>
        </Row>
      </footer>
    </>
  );
};

export default Footer;
